import { graphql } from 'react-relay';
export const ContentSchedulePublishQuery = graphql`
	query ContentSchedulePublishQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				schedulePublishDate
			}
		}
	}
`;
